module.exports = __webpack_public_path__ + "static/img/torso18.ea131735.jpg";